import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-milestone-status-count',
  templateUrl: './milestone-status-count.component.html',
  styleUrl: './milestone-status-count.component.css'
})
export class MilestoneStatusCountComponent  implements OnInit {
 @Input () quarterlyOutcomesList:any={}
  notStarted = 0;
  ongoing = 0;
  completed = 0;
  delayed = 0;
  terminated = 0;

  ngOnInit(): void {
    this.calculateStatusCounts();
  }
  calculateStatusCounts(): void {
    this.notStarted = this.quarterlyOutcomesList.milestones.filter((m:any) => m.status == 1).length;
    this.ongoing = this.quarterlyOutcomesList.milestones.filter((m:any)=> m.status == 2).length;
    this.completed = this.quarterlyOutcomesList.milestones.filter((m:any) => m.status == 3).length;
    this.delayed = this.quarterlyOutcomesList.milestones.filter((m:any) => m.status == 4).length;
    this.terminated = this.quarterlyOutcomesList.milestones.filter((m:any) => m.status == 5).length;
  }
}
